import { IServices } from "@netent/origin";
import { ISpinState, SpinButtonPosition } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const spinState: FeatureStateCreator<ISpinState> = (
  services: IServices
): ISpinState => ({
  enabled:
    !services.gameRound.isRoundActive() ||
    (services.gameRound.isRoundActive() &&
      services.spin.isQuickStopAvailable()),
  spinning: services.gameRound.isRoundActive(),
  buttonPosition: SpinButtonPosition.DOCKED
});
